"use client";

import type { CSSProperties } from "react";

type GlobalErrorProps = { error: Error & { digest?: string }; reset: () => void };

const containerStyle: CSSProperties = {
  margin: "auto",
  maxWidth: 600,
  padding: "4rem 1.5rem",
  textAlign: "center",
};

const headingStyle: CSSProperties = { fontSize: "2rem", fontWeight: 600 };

const messageStyle: CSSProperties = { color: "#666", marginTop: "1rem" };

const buttonStyle: CSSProperties = {
  cursor: "pointer",
  marginTop: "2rem",
  padding: "0.5rem 1.25rem",
};

export default function GlobalError({ reset }: GlobalErrorProps) {
  return (
    <html lang="en">
      <body>
        <div style={containerStyle}>
          <div role="alert">
            <h1 style={headingStyle}>Something went wrong</h1>
            <p style={messageStyle}>An unexpected error occurred.</p>
          </div>
          <button onClick={reset} style={buttonStyle} type="button">
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
